import { ReactComponent as ExclamationSvg } from '../../assets/icons/exclamation.svg';

export const ExclamationIcon: SvgIcon = (props) => {
    return <ExclamationSvg {...props} />;
};
